import React, { useContext } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import { PropsFromRedux } from '.';
import cartImg from '../../../../assets/images/greencart.svg';
import PersonalShopperContext from '../../../../context/PersonalShopperContex/PersonalShopperContex';
import { API_KEYS } from '../../../../interfaces/api';
import { BeatLoader } from '../../../Spinners/Spinner';


interface Props extends PropsFromRedux {}

const OrderSuccess: React.FC<Props> = ({ 
  hideModal,
  showModal,
  modal,
  resetApi,
  getHistory,
  historyState
 }) => {

  const history = useHistory();
  const location = useLocation();
  const { shopperData, setShopperData } = useContext(PersonalShopperContext);

  React.useEffect(() => () => {
    resetApi(API_KEYS.GET_PERSONAL_SHOPPING_LIST);
},
[resetApi]);

  const closeModal = () => {
    getHistory();
  }
  
  React.useEffect(()=> {
    if(!historyState?.loading && historyState?.response?.Object){
      setShopperData({});
      history.push('/shopping-history');
      hideModal();
    }
}, [!historyState?.loading, historyState?.response?.Object])

  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return( 
    <div className="w-full px-2 bg-white lg:px-12 py-12 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
         <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={cartImg} alt="GIG App" className="w-28 my-4" />
    </div>
     <div className="w-full my-6 text-center">
         <h2 className="mb-1 text-lg font-medium text-black">Shopping Order Received</h2>
         <p className=" w-96 text-sm text-gray-400">We would process and send a proforma invoice once availability of item is comfirmed.</p>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-3 my-6" 
      type="button" 
      disabled={historyState?.loading}
      onClick={() => closeModal()}
      >
       {historyState?.loading ? <BeatLoader color="white" /> : 'Close'}
  </button>
  </div>
  );
  // </ModalWrapper>
};

export default OrderSuccess;
